export default __webpack_public_path__ + "static/PPNeueMontreal-Medium-4105b1cc8dd5fc2951417b5469d9c5f5.woff2";